import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { pageConfigurationActions } from '@/store/PageConfiguration/PageConfigurationSagas'
import useBusinessType from '@/shared/hooks/useBusinessType'
import { useParams } from 'react-router-dom'
import SubscriptionForm from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionForm'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import CommonFallback from '@/shared/components/CommonFallback'
import {
  selectPageConfigurationData,
  selectPageConfigurationError,
} from '@/store/PageConfiguration/PageConfigurationSelectors'
import FormStatusError from './FormStatusError'

const EditForm = () => {
  const dispatch = useDispatch()
  const { id: idFromBackend } = useSelector(selectPageConfigurationData)
  const { status } = useSelector(selectPageConfigurationError)
  const { loaderRoutes, loaderRoutesEnergy, loaderRoutesInsurance, country } = useSelector(selectAuthData)
  const { getApplicationUrl } = useBusinessType({
    loaderRoutesEnergy,
    loaderRoutes,
    loaderRoutesInsurance,
    modulesStatuses: {},
    modulesStatusesEnergy: {},
    modulesStatusesInsurance: {},
  })
  const initUrl = getApplicationUrl('telesales-form-new') ?? ''
  const { id } = useParams()

  useEffect(() => {
    dispatch({ type: pageConfigurationActions.INITIALIZE, initUrl: initUrl.replace('*', id) })
  }, [id])

  if (status && status !== 200) {
    return <FormStatusError statusCode={status} />
  }

  if (!idFromBackend) {
    return <CommonFallback />
  }

  return <SubscriptionForm country={country} id={id} />
}

export default EditForm
